<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">{{ $t('dtp.title') }} - {{ autoTitle }}</h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <dtp-table class="mt-4" :car-id="$route.params.autoId" simple />
  </v-layout>
</template>

<script>
import DtpTable from '@/components/dtp/DtpTable.vue';

export default {
  components: { DtpTable },
  computed: {
    autoTitle() {
      return this.$store.getters['auto/getAutoTitle'];
    },
  },
};
</script>

<style></style>
